var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 287,
    height: 318,
    viewBox: "0 0 287 318",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M143.5 31.0547C111.373 31.0547 81.7227 41.634 57.813 59.5215V0H0V161.484H58.866C65.308 120.43 100.739 89.0234 143.5 89.0234C190.824 89.0234 229.187 127.49 229.187 174.941C229.187 217.093 198.918 252.164 158.986 259.452V318C230.942 310.257 287 249.162 287 174.941C287 95.4828 222.745 31.0547 143.5 31.0547Z",
    fill: "#007FCF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2767 190H1C8.23307 257.89 62.2853 311.692 130 318V259.488C94.185 253.824 65.7473 225.771 59.2767 190Z",
    fill: "#5CC0FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCircle);
export default __webpack_public_path__ + "static/media/LogoCircle.6d1c0d55.svg";
export { ForwardRef as ReactComponent };